@defer (when value()) {
  <app-user-form
    [(value)]="value"
    [edit]="false"
    [id]="id"
    [profile]="profile()"
    [access]="access()"
  ></app-user-form>
}
